export enum SearchActions {
  SetValue = "setValue",
  Reset = "reset",
  SetResults = "setResults",
}
